
import Component, { mixins } from "vue-class-component"
import Calculator from "../mixins/Calculator.vue"
import { Bestellung } from "mangdto"
import { Prop } from "vue-property-decorator"
import { EnumFormatter } from "mangutil"

@Component
export default class BestellungRowLieferung extends mixins(Calculator) {
  @Prop() bestellung: Bestellung

  formatiereLieferungStatus(bestellung: Bestellung): string {
    return EnumFormatter.formatLieferungStatus(
      bestellung.lieferung.lieferungStatus,
    )
  }
}
